export default "__VITE_ASSET__3168c4be__"